import {ProductInterface} from "../../interfaces/catalog/ProductInterface";
import Product from "./Product";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import {sortProductsByStock} from "../../utils/productSort";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function ProductSlider({products,  header}: {
    products: ProductInterface[],
    header: string
}) {

    const sortedProducts = sortProductsByStock(products);

    return (<div className="prod-cat">
        <div className="container">
            <div className="d-flex flex-column prod-cat__row">
                <div className="prod-cat__item">
                    <div className="prod-cat__title t-two">{header}</div>
                    <Swiper
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={12}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                        autoplay={{ delay: 5000, disableOnInteraction: false }}
                        breakpoints={{
                            576: {
                                slidesPerView: 2,
                                spaceBetween: 12,
                            },
                            768: {
                                slidesPerView: 3,
                                spaceBetween: 24,
                            },
                            992: {
                                slidesPerView: 4,
                                spaceBetween: 24,
                            },
                        }}
                    >
                        {sortedProducts.map(product => (
                            <SwiperSlide key={product.id}>
                                <div className="col-12 prod-card"><Product product={product} /></div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    </div>)
}